import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useSessionWarningStyles = makeStyles({
  overlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: tokens.colorBackgroundOverlay,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999999,
  },
  surface: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    boxShadow: tokens.shadow64,
    maxWidth: '480px',
    width: '90%',
    ...shorthands.padding('32px'),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingVerticalM),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '64px',
    height: '64px',
    ...shorthands.borderRadius('50%'),
    backgroundColor: tokens.colorBrandBackground2,
  },
  warningIcon: {
    fontSize: fontScale.heading,
    color: tokens.colorBrandForeground1,
  },
  title: {
    fontSize: fontScale.title,
    textAlign: 'center',
    color: tokens.colorNeutralForeground1,
  },
  message: {
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
    fontSize: fontScale.body,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    ...shorthands.gap(tokens.spacingHorizontalL),
    paddingTop: tokens.spacingVerticalS,
    width: '100%',
  },
  signOutButton: {
    minWidth: '140px',
  },
  extendButton: {
    minWidth: '180px',
  },
});
